import { createStore, applyMiddleware } from 'redux';

import thunk from 'redux-thunk';
import reducer from './root-reducer';
import { initialState } from './root-state';

export const store = createStore(reducer, initialState, applyMiddleware(thunk));
